function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './TravellersType.css';
import React, { useEffect, useState } from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import HobbiesAndTravellersTypeCarousel from './components/HobbiesAndTravellersTypeComponents/HobbiesAndTravellersTypeCarousel';
import { get } from '../../utils';
import { STEPS } from './AccountAuthorization';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
const TravellersType = _ref => {
  let {
    interestingItems,
    buttonLabel,
    getActiveStep,
    getRegisterData,
    registerData,
    params,
    skipButtonLabel,
    eventsAnalytics
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const cardsTravellersInitial = interestingItems;
  const buttonText = get(buttonLabel, 'jss.value');
  const [cardsTravellers, setCardsTravellers] = useState([]);
  useEffect(() => {
    if (cardsTravellersInitial && cardsTravellersInitial.length) {
      const updatedItems = cardsTravellersInitial.map(item => _objectSpread(_objectSpread({}, item), {}, {
        active: item.key.targetItem.id === registerData.travelerType
      }));
      setCardsTravellers(updatedItems);
    }
  }, [cardsTravellersInitial]);
  const onTravellerCardChoose = key => {
    const cardsTravellersUpdated = [...cardsTravellers];
    cardsTravellersUpdated.map(el => {
      const id = get(el, 'key.targetItem.id');
      if (id === key) {
        el.active = !el.active;
      }
    });
    setCardsTravellers(cardsTravellersUpdated);
  };
  const onSkipButtton = () => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['signinCTAsAnalytics'], params), `travellers type  :${skipButtonLabel}`);
    onSubmitTravelers();
  };
  const onSubmitTravelers = () => {
    const chosenItems = cardsTravellers && cardsTravellers.filter(el => el.active).map(el => el.key.targetItem.id);
    let userData = registerData;
    const chosenItemNames = cardsTravellers && cardsTravellers.filter(el => el.active).map(el => el.key.targetItem.name);
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['signupCTAsAnalytics'], params), ['travellers type ', `${chosenItemNames}`]);
    userData = _objectSpread(_objectSpread({}, registerData), {
      travelerType: chosenItems
    });
    getRegisterData(userData);
    getActiveStep(STEPS.STEP4);
  };
  const isSubmitTravellersDisaled = cardsTravellers && !cardsTravellers.filter(el => el.active).length;
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: `${cardsTravellers && cardsTravellers.length > 4 ? 'carousel-container' : ''}`
  }, cardsTravellers && cardsTravellers.length > 0 && /*#__PURE__*/React.createElement(HobbiesAndTravellersTypeCarousel, {
    cards: cardsTravellers,
    onItemChoose: onTravellerCardChoose,
    carouselView: cardsTravellers.length > 4
  }), /*#__PURE__*/React.createElement("div", {
    className: `${cardsTravellers.length > 4 ? 'carousel-container-navigation' : ''} ${!cardsTravellers || cardsTravellers.length === 0 ? 'pt-5' : ''}`
  }, buttonText && /*#__PURE__*/React.createElement("button", {
    onClick: onSubmitTravelers,
    className: "btn btn-primary",
    disabled: isSubmitTravellersDisaled
  }, buttonText), skipButtonLabel && /*#__PURE__*/React.createElement("button", {
    onClick: onSkipButtton,
    className: "btn btn-tertiary"
  }, skipButtonLabel))));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `${rtl ? rtlStyles : ltrStyles} ${commonStyles}`
  }, children);
};
const commonStyles = "coqqzgq";
const ltrStyles = "lt6wzdi";
const rtlStyles = "rdt1hjz";
export default TravellersType;